import type { ComponentInfo } from "@builder.io/sdk-react";

export const CATEGORY_NAME_INPUTS = [
  {
    name: "name",
    type: "string",
    defaultValue: "",
  },
] as const satisfies ComponentInfo["inputs"];

export type CategoryNameProps = BuilderComponentProps<typeof CATEGORY_NAME_INPUTS>;
